// extracted by mini-css-extract-plugin
module.exports = {"fieldWithIcon":"FieldIcon_fieldWithIcon__dEemL","iconWrapper":"FieldIcon_iconWrapper__AK0x_","icon":"FieldIcon_icon__2I6RJ"};